import { StandardAvailabilityQueryFragment, StudioModelQueryFragment } from '../constants/query_fragments'

export const CREATE_STUDIO_MUTATION = /* GraphQL */ `
  mutation CreateStudio(
    $input: CreateStudioInput!
    $condition: ModelStudioConditionInput
  ) {
    createStudio(input: $input, condition: $condition) {
      ${StudioModelQueryFragment}
    }
  }
`

export const UPDATE_STUDIO_MUTATION = /* GraphQL */ `
mutation UpdateStudio(
  $input: UpdateStudioInput!
) {
  updateStudio(input: $input) {
    ${StudioModelQueryFragment}
  }
}
`;

export const GET_USER_STUDIOS_QUERY = /* GraphQL */ `
  query GetUser($id: ID!, , $limit: Int) {
    getUser(id: $id) {
      studios(limit: $limit) {
        nextToken
        items {
          ${StudioModelQueryFragment}
        }
      }
    }
  }
`

export const GET_ALL_STUDIOS_QUERY = /* GraphQL */ `
  query ListStudios(
    $limit: Int
    $nextToken: String
    $filter: ModelStudioFilterInput
  ) {
    listStudios(
      limit: $limit
      nextToken: $nextToken
      filter: $filter
    ) {
      items {
        ${StudioModelQueryFragment}
      }
      nextToken
    }
  }
`

export const GET_STUDIO_BY_ID_QUERY = /* GraphQL */ `
  query GetStudio($id: ID!) {
    getStudio(id: $id) {
      ${StudioModelQueryFragment}
    }
  }
`;

export const GET_STUDIO_PENDING_ACTIONS_QUERY = /* GraphQL */ `
  query GetStudio($id: ID!) {
    getStudio(id: $id) {
      pendingAdminActions
    }
  }
`;

export const DELETE_STUDIO_MUTATION = /* GraphQL */ `
  mutation DeleteStudio(
    $input: DeleteStudioInput!
  ) {
    deleteStudio(input: $input) {
      id
    }
  }
`

export const REQUEST_BOOKING_MUTATION = /* GraphQL */ `
  mutation RequestBooking($input: RequestBookingInput!) {
    requestBooking(input: $input) {
      bookingId
      studioId
      requesterUserId
      hostUserId
      startTime
      endTime
    }
  }
`;

export const GET_OPEN_AVAILABILITIES_QUERY = /* GraphQL */ `
  query GetOpenAvailabilities($input: GetOpenAvailabilitiesInput!) {
    getOpenAvailabilities(input: $input) {
      timeslots {
        startDate
        endDate
      }
    }
  }
`;

export const RESPOND_TO_BOOKING_REQUEST_MUTATION = /* GraphQL */ `
  mutation RespondToBookingRequest($input: RespondBookingRequestInput!) {
    respondToBookingRequest(input: $input) {
      status
    }
  }
`;

export const GET_BOOKING_CHECKOUT_SESSION_QUERY = /* GraphQL */ `
  query GetBookingCheckoutSession($input: GetBookingCheckoutSessionInput) {
    getBookingCheckoutSession(input: $input) {
      checkoutUrl
    }
  }
`;

export const GET_STUDIO_AVAILABILITY_QUERY = /* GraphQL */ `
  query GetStudio($id: ID!) {
    getStudio(id: $id) {
      standardAvailability {
        ${StandardAvailabilityQueryFragment}
      }
      availabilityExceptions {
        isAvailable
        timeRange {
          startDate
          endDate
        }
      }
    }
  }
`;
